import { ConcreteExperienceMessage } from '@dadohr/shared/domainTypes/experience';
import { useState } from 'react';
import { ColoredChipDark } from '../../../../../components/ColoredChip';
import { useUnsafeTranslation } from '../../../../../i18next';
import { InDeliveryChip } from '../../../components/StatusChip';

const TRUE_MESSAGE_STATUS_CUT_OFF = 1658700000000; // Monday, July 25th 2022
export const SECOND_MESSAGE_STATUS_CUT_OFF = 1721981577409; // July 26th 2024 - this is where we started to rely on concrete messages only

// Adjust cut-off and don't accept anything which doesn't have a concrete message at all.
// There should always be something there.
// Maybe highlight these cases specifically.

export const MessageDoneSendStatus = ({
  concreteMessages
}: {
  concreteMessages: ConcreteExperienceMessage[];
}) => {
  const { t } = useUnsafeTranslation();
  const [n] = useState(Date.now());
  if (n < TRUE_MESSAGE_STATUS_CUT_OFF) {
    return (
      <ColoredChipDark size="small" color="green">
        {t('Sent')}
      </ColoredChipDark>
    );
  }
  if (n < SECOND_MESSAGE_STATUS_CUT_OFF && !concreteMessages.length) {
    return (
      <ColoredChipDark size="small" color="green">
        {t('Sent')}
      </ColoredChipDark>
    );
  }

  const successfulMessages = concreteMessages.filter((m) => m.status === 'OK');
  const erroredMessages = concreteMessages.filter(
    (m) => m.status === 'ERROR' || m.status === 'BOUNCED'
  );
  // const otherMessages = concreteMessages.filter(
  //   (m) => m.status !== 'OK' && m.status !== 'ERROR' && m.status !== 'BOUNCED'
  // );

  if (!successfulMessages.length && !erroredMessages.length) {
    return <InDeliveryChip />;
  }

  if (erroredMessages.length && !successfulMessages.length) {
    // TODO - specifically check for Bounced status
    // if (mostRecentConcreteMessage.status === 'BOUNCED') {
    //   return (
    //     <ColoredChipDark size="small" color="red">
    //       {t('Bounced')}
    //     </ColoredChipDark>
    //   );
    // }
    return (
      <ColoredChipDark size="small" color="red">
        {t('Error')}
      </ColoredChipDark>
    );
  }

  if (successfulMessages.length) {
    // TODO maybe add a tooltip indicating if there are also failed ones
    return (
      <ColoredChipDark size="small" color="green">
        {t('Sent')}
      </ColoredChipDark>
    );
  }
  return (
    <ColoredChipDark size="small" color="gray">
      {t('Unknown')}
    </ColoredChipDark>
  );
};
